
'use strict';

import Analytics from  '../Analytics/Analytics';
var $ = require('jquery'),
  config = require('../../js/config'),
  OfficeTertiaryScrollerView = require('./OfficeTertiaryScrollerView'),
  mediator = require('mediatorjs'),
  _ = require('underscore'),
  REGION_OFFSET = 100,
  isShowingClass = config.classes.isShowing,
  isDisabledClass = config.classes.isDisabled,
  isFadedClass = config.classes.isFaded,
  Backbone = require('backbone'),
  $global = require('../../js/globalElements');

Backbone.$ = $;

var OfficeRegionView = Backbone.View.extend({

  events: {
    'click .js-toggle-drawer': 'toggleDrawer',
    'click .Region-item-map': 'pushMapClicktoDataLayer'
  },

  initialize: function() {

    _.bindAll(this, 'filterOfficesOnLocation');
    this.$drawer = this.$('.js-region-dropdown');
    this.$tertiaryDropdown = this.$('.js-tertiary-selector'); //Only US region will have this
    this.$offices = this.$('.js-region-office');
    this.countryId = this.$drawer.data('region');
    this.hasTertiaryDropdown = this.$tertiaryDropdown.length;
    if (this.hasTertiaryDropdown) {
      this.tertiaryDropdown = new OfficeTertiaryScrollerView({
        el: this.$tertiaryDropdown[0]
      });
      mediator.on(config.events.offices.showSubRegion, this.filterOfficesOnLocation);
    }

  },

  pushMapClicktoDataLayer: function(e) {
    e.preventDefault();
    let analyticsData = {
      event: config.analytics.events.click,
      category: config.analytics.categoryTypes.Support,
      action: config.analytics.actions.FindAnOffice,
      label: 'Map - ' + e.target.getAttribute('data-region-item-name')
    };
    Analytics.pushToEventFramework(analyticsData);
    var url = e.target.getAttribute('data-region-url');
    window.open(url, '_blank');
  },

  /**
   * Will be true if region has childeren that can be shown based on the
   * currently selected Division
   */
  isActive: true,

  /**
   * Is currently showing the dropdown
   */
  isShowing: false,

  currentDivisionFilter: 'all',

  toggleDrawer: function(e) {
    e.preventDefault();
    let analyticsData = {
      event: config.analytics.events.click,
      category: config.analytics.categoryTypes.Support,
      action: config.analytics.actions.FindAnOffice,
      label: e.target.getAttribute('data-country-code')
    };
    Analytics.pushToEventFramework(analyticsData);
    if (this.isShowing) {
      this.hide();
      e.target.ariaExpanded = false;
      mediator.trigger(config.events.offices.hideRegion);
      return;
    }
    e.target.ariaExpanded = true;
    this.show();
  },

  deactivateRegion: function() {
    this.$el.addClass(isDisabledClass);
    if (this.isShowing) {
      mediator.trigger(config.events.offices.hideRegion);
      this.hide();
    }
    this.isActive = false;
  },

  activateRegion: function() {
    this.$el.removeClass(isDisabledClass);
    this.isActive = true;
  },

  /**
   * Hide all and then show offices based on one of two passed params.
   * Division relates to Arrow divisions and they contain offices per division around the world.
   * Location relates currently to states in US only. So this could only be passed when we are in US region dropdown
   * @paramOne param - division or state reference to be mapped against the related data attribute.
   * @paramTwo value - the actual value to match against.
   * The show hide behaviour will be a combo of these params if one is stored already as a filter.
   */
  filterOffices: function(location) {
    var self = this,
      areAllhidden = true;

    this.hideAllOffices();

    this.$offices.each(function() {
      var $this = $(this);

      //First filter by division
      if (self.currentDivisionFilter === 'all' || $this.data('division').toLowerCase() === self.currentDivisionFilter) {

        //further filtering by location if it passed as parameter and the attribute exists on the element
        if (location && $this.data('location')) {
          if (location === 'all' || $this.data('location').toLowerCase() === location) {
            self.showOffice($this);
          }
          areAllhidden = false;
          return;
        }
        self.showOffice($this);
        areAllhidden = false;

      }
    });

    if (areAllhidden) {
      this.deactivateRegion();
    }
  },

  filterOfficesOnDivision: function(division) {
    this.currentDivisionFilter = division;
    if (this.hasTertiaryDropdown) {
      this.tertiaryDropdown.reset();
    }
    this.filterOffices();
  },

  filterOfficesOnLocation: function(location) {
    this.filterOffices(location);
  },

  /**
   * Show the individual office
   * and activate the parent region
   */
  showOffice: function($elem) {
    this.activateRegion();
    $elem.show();
  },

  hideAllOffices: function() {
    this.$offices.hide();
  },

  showAllOffices: function() {
    if (this.hasTertiaryDropdown) {
      this.tertiaryDropdown.reset();
    }
    this.$offices.show();
    this.activateRegion();
  },

  /**
   * Will be faded if another region is showing.
   */
  fade: function() {
    this.$el.addClass(isFadedClass);
  },

  unfade: function() {
    this.$el.removeClass(isFadedClass);
  },

  show: function() {
    if (this.isActive) {
      mediator.trigger(config.events.offices.showRegion, this.countryId);
      this.$drawer.addClass(isShowingClass);
      this.$el.removeClass(isFadedClass);
      this.isShowing = true;
      $global.$htmlBody.animate({ scrollTop: this.$el.offset().top - REGION_OFFSET}, 300);
    }
  },

  hide: function() {
    this.$drawer.removeClass(isShowingClass);
    this.isShowing = false;
  }
});

module.exports = OfficeRegionView;



// WEBPACK FOOTER //
// ./assets/components/Offices/OfficeRegionView.js